/**
 * @module
 *
 * @import {UserData} from "./user-data.js"
 */
import {undefined} from '@acng/frontend-bounty/std/value.js';

import {portal} from '../../core/portal.js';
import {startUpLanguage} from '../../core/service/env.js';

/**
 * @type {UserData}
 */
const guestData = {
  id: 0,
  pool_id: 0,
  partner_pool: 2,
  uid: '',
  email: '',
  coins: 0,
  points: 0,
  level: 0,
  split_tests: [],
  preferred_language: startUpLanguage,
  signup_wl_id: 0,
  signup_type: 'soi',
  first_login: '',
  confirmed_at: null,
  tester: false,
  first_login_country: null,
  use_utm: portal.is_international,
  mailing: {
    transaction: false,
    informer: false,
    informer_ratio: 0,
    bonus: false,
    newsletter: false,
  },
  active_features: {
    voice_messages: false,
    messenger: false,
  },
  languages: {
    selected: null,
    detected: null,
  },
  usergroups: [],
  redirectPath: undefined,
  nickname: 'guest',
  guest: true,
  fsk: portal.guest_fsk,
  niche: portal.niche,
  list_sorting_suffix: portal.list_sorting_suffix,
  is_international: portal.is_international,
  doi_at: null,
  doi_reward_group: 'vip_points',
};

export {guestData};
